define([
    "jquery",
    "components/modal",
    "core/urls",
    "components/fake-progress",
    "core/iterate",
    "core/utilities",
    'core/uploader',
    'core/browser-storage',
    'core/logo-repository',
    "components/custom-domain",
    "components/selectize",
    '@claviska/jquery-minicolors'
], function (
    $,
    modal,
    urls,
    FakeProgress,
    iterate,
    utilities,
    uploader,
    storage,
    logo_repository,
    customDomain
) {
    var nodes = {
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".create-survey-s2"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
        previewModal: document.querySelector(".modal-template-preview"),
        previewButton: document.querySelector(".preview-email"),
        importHeader: document.querySelector("h3.import-survey"),
        importForm: document.querySelector("form.import-survey-form"),
        mainForm: document.querySelector("form.main-form"),
        form: {
            brandColor: document.querySelector("#id_color"),
            brandColorError: document.querySelector(".input-error.brand-color"),
            subject: document.querySelector("#id_subject"),
            subjectError: document.querySelector(".input-error.subject"),
            intro: document.querySelector("#id_introduction"),
            introError: document.querySelector(".input-error.intro"),
            resetButtons: document.querySelectorAll(".reset-input"),
            emailAddress: document.querySelector("#from_address"),
            emailAddressError: document.querySelector(".input-error.email-address"),
            emailName: document.querySelector("#from_name"),
            emailNameError: document.querySelector(".input-error.email-name"),
        },
        hiddenInputs: {
            initialForms: document.querySelector("#id_form-INITIAL_FORMS"),
            totalFormsInput: document.querySelector('[name="form-TOTAL_FORMS"]'),
        },
        submitButton: document.querySelector(".projects-survey-submit_js"),
        previewButton: document.querySelector(".preview-email_js"),
        imgPreview: {
            withLogo: document.querySelector(".conf-mail-withlogo_js"),
            noLogo: document.querySelector(".conf-mail-nologo_js"),
            controls: document.querySelector(".conf-mail-upload-ctrl_js"),
            openBtn: document.querySelector(".uploader-open_js"),
            minusLogo: document.querySelector(".uploader-delete-logo_js")
        },
        logoPicker: document.querySelector(".logo-picker_js"),
        modalUploadLogoContent: document.querySelector('.modal-template-upload_js'),
        progress: document.querySelector(".new-progress"),
        getLogosContainer: function () {
            return document.querySelector(".modal-template-upload_js .logos_js")
        },
        loaderElement: document.querySelector(".marketing-loader"),
        loaderHint: document.querySelector(".marketing-loader .loader-bar-wrap_hint"),
    };

    var createdModal = modal.create(nodes.modal, function (el) {});

    let modalTemplate = document.querySelector(".modal-template-leave_js");
    let hrefs = document.querySelectorAll("a[href]"); 
    let surveyId = document.querySelector("[data-survey-id]").dataset.surveyId;
    let domainSelector = nodes.mainForm.querySelector("#id_domain");

    let hrefsToIgnore = [
        urls['projects:start_projects_survey'](surveyId),
        urls['projects:start_projects_survey_s2'](surveyId),
        urls['projects:start_projects_survey_s3'](surveyId),
        urls['projects:start_projects_survey_s4'](surveyId),
    ];

    let loadingScreen = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );
    
    function exitWarningGeneric() {
        iterate(hrefs, function (node) {
            node.addEventListener("click", (event) => {
                utilities.confirmPageExit(
                    event,
                    createdModal,
                    modalTemplate,
                    null,
                    hrefsToIgnore
                );
            });
        });
    }

    let validationConfigs = [
        {
            input: nodes.form.subject,
            errorNode: nodes.form.subjectError,
            validations: ["hasValue", "notTooLong"],
        },
        {
            input: nodes.form.intro,
            errorNode: nodes.form.introError,
            validations: ["hasValue", "notTooLong"],
        },
        {
            input: nodes.form.brandColor,
            errorNode: nodes.form.brandColorError,
            validations: ["hasValue"],
        }
    ];

    var progress = (function () {
        let p = nodes.progress;
        p.classList.add("disabled");
        return {
            start: function () {
                p.classList.remove("disabled");
            },
            stop: function () {
                p.classList.add("disabled");
            }
        }
    })();

    let showEmailPreview = async (surveyId) => {
        await fetch(urls['projects:email_preview'](surveyId), {
            method: "POST",
            body: new FormData(nodes.mainForm),
        })
        .then(response => response.text())
        .then((text) => {
            try {
                // Try to parse the response as JSON
                const data = JSON.parse(text);
                // The response was a JSON object indicating an error
                Object.keys(data).forEach((field, i) => {
                    if(field === "introduction") {
                        nodes.form.intro.classList.add("error");
                        nodes.form.introError.innerText = data[field][0].message;
                        nodes.form.introError.classList.remove("hide");
                    }

                    if(field === "subject") {
                        nodes.form.subject.classList.add("error");
                        nodes.form.subjectError.innerText = data[field][0].message;
                        nodes.form.subjectError.classList.remove("hide");
                    }
                })
              } catch(err) {
                // The response wasn't a JSON object
                // Show preview
                let iframe = nodes.previewModal.querySelector('iframe');
                iframe.srcdoc = text;

                createdModal.open({
                    class: "survey-preview-modal",
                    content: nodes.previewModal.innerHTML,
                    title: "Email Preview"
                }, function (el) {});
              }
        })
    }

    let insertAtCursor = (field, value) => {
        //IE support
        if (document.selection) {
            field.focus();
            sel = document.selection.createRange();
            sel.text = value;
        }
        else if (field.selectionStart || field.selectionStart == '0') {
            var startPos = field.selectionStart;
            var endPos = field.selectionEnd;
            field.value = field.value.substring(0, startPos)
                + value
                + field.value.substring(endPos, field.value.length);
        } else {
            field.value += value;
        }

        field.click();
    }      

    let handleTextInserts = (buttonClass, value, wrapperClass) => {
        // this function inserts a string (value) inside a text field
        // used for adding placeholders for [name] and [project] that will be 
        // swapped out for real values
        let wrapper = document.querySelector(wrapperClass)
        let button = wrapper.querySelector(buttonClass);
        let input = wrapper.querySelector("textarea");
        if(!input) {
            input = wrapper.querySelector("input");
        }

        if(input.value.indexOf(value) > -1) {
            button.classList.add("disabled");
        }

        input.addEventListener("input", () => {
            if(input.value.indexOf(value) === -1) {
                button.classList.remove("disabled");
            } else {
                button.classList.add("disabled");
            }
        })

        button.addEventListener("click", () => {
            if(!button.classList.contains("disabled")) {
                insertAtCursor(input, value)
                button.classList.add("disabled")
            }
        })
    }

    let openUploadModal = (uploadcare) => {
        createdModal.open(null, function (el) {
            let btn = el.querySelector(".upload-care_js");

            btn.addEventListener("click", function () {
                let dialog = uploadcare.openDialog(null, {
                    validators: [
                        uploader.maxSizeValidator(window.UPLOADCARE_FILE_MAX_MB * 1024 * 1024),
                        uploader.fileTypeValidator('png jpeg jpg gif')
                    ]
                });

                dialog.done(function imageUploaded(result) {

                    createdModal.close();
                    progress.start();

                    result.done(function (fileInfo) {
                        logo_repository
                            .LogoRepository
                            .save(fileInfo.uuid)
                            .done(function (logo) 
                        {
                            let img = {
                                title: logo.title,
                                id: logo.id,
                                src: logo.resource_thumbnail,
                            };

                            imageWorker.set(img);
                            addImgToList(nodes.getLogosContainer(), img);
                            addImgToPreview(nodes.imgPreview, img);
                            waitImg(logo.resource_thumbnail, function () {
                                showPreview(nodes.imgPreview);
                                progress.stop();
                            })
                        });
                    });

                }).fail(function () {
                    nodes.imgPreview.noLogo.classList.remove("disabled");
                    progress.stop();
                });

            });

            var logosWrapper = el.querySelector(".logos_js");

            function onLogoClick(e) {

                var image = {};
                var target = e.target;
                var id = target.getAttribute("data-id");

                if (!id) {
                    return
                }

                image.id = id;
                image.src = target.getAttribute("data-src");
                image.title = target.getAttribute("data-title");

                addImgToPreview(nodes.imgPreview, image);

                imageWorker.set(image);

                showPreview(nodes.imgPreview);

                createdModal.close(function () {
                    logosWrapper.removeEventListener("click", onLogoClick);
                });

            }

            let showMoreButton = el.querySelector(".show-more_js");
            function showAllLogos() {
                let hiddenLogos = el.querySelectorAll(".logo-item_js.hide-mobile");
                hiddenLogos.forEach(logo => {
                    logo.classList.remove("hide-mobile");
                });
                showMoreButton.innerText = "Close"
                showMoreButton.removeEventListener("click", showAllLogos);
                showMoreButton.addEventListener("click", () => createdModal.close());
            }

            logosWrapper.addEventListener("click", onLogoClick);
            el.querySelector(".modal-close_js").addEventListener("click", () => {
                createdModal.close();
            });
            showMoreButton.addEventListener("click", showAllLogos);

        }, nodes.modalUploadLogoContent)

    }

    let imageWorker = {
        set: function (img) {
            this.image = img
        },
        save: function () {
            storage.addObj("conf-email-img", this.image || {id: "", title: "", src: ""});
        },
        get: function () {
            return this.image
        },
        remove: function () {
            storage.removeItem("conf-email-img");
        }
    };

    function addImgToList(wrap, imageData) {

        let div = document.createElement("div");
        div.style.backgroundImage = "url('" + imageData.src + "')";

        ['id', "title", "src"].forEach(function (key) {
            div.setAttribute("data-" + key, imageData[key]);
        });

        div.classList.add("sb-modal-upload__select-item");
        div.classList.add("logo-item_js");

        div.setAttribute("alt", imageData.title);
        wrap.prepend(div);

    }

    let waitImg = (src, onLoaded) => {
        var preloaderImg = document.createElement("img");
        preloaderImg.src = src;
        preloaderImg.addEventListener('load', (event) => {
            preloaderImg = null;
            onLoaded();
        });
    }

    let addImgToPreview = (imageContainer, img) => {
        setImgId(img.id);
        imageContainer.withLogo.style.backgroundImage = 'url(' + img.src + ')';
        imageContainer.withLogo.setAttribute('alt', img.name);
        ['id', "uuid"].forEach(function (key) {
            imageContainer.withLogo.setAttribute('data' + key, img[key]);
        });
    }

    let setImgId = (id) => {
        document.querySelector("#id_logo").value = id;
    }

    let removeImgId = () => {
        document.querySelector("#id_logo").value = "";
        imageWorker.remove();
    }

    let showPreview = (nodes) => {
        nodes.controls.classList.remove("disabled");
        nodes.noLogo.classList.add("disabled");
        nodes.withLogo.classList.remove("disabled");
    }

    let hidePreview = (nodes) => {
        removeImgId();
        nodes.controls.classList.add("disabled");
        nodes.noLogo.classList.remove("disabled");
        nodes.withLogo.classList.add("disabled");
    }

    let setImg = (image) => {
        imageWorker.set(image);
        addImgToPreview(nodes.imgPreview, image);
        if (image.id)
            showPreview(nodes.imgPreview, image);
    }

    let setDefaultLogo = () => {
        let imgID = document.querySelector("#id_logo").value;
        let imgElement = document.querySelector(`.logo-item_js[data-id="${imgID}"]`);

        if (!imgElement) return;

        let imgConfig = {
            title: imgElement.getAttribute("data-title"),
            id: imgID,
            src: imgElement.getAttribute("data-src"),
        }

        setImg(imgConfig);
    }

    uploaderCallback = (uploadcare) => {
        nodes.logoPicker.addEventListener("dragover", function (e) {
            nodes.logoPicker.classList.add("dragover");
        });

        nodes.logoPicker.addEventListener("click", function (e) {
            openUploadModal(uploadcare);
        });

        nodes.logoPicker.addEventListener("dragleave", function (e) {
            nodes.logoPicker.classList.remove("dragover");
        });

        uploadcare.dragdrop.uploadDrop(nodes.logoPicker, function (file) {

            nodes.logoPicker.classList.remove("dragover");
            progress.start();

            file.done(function (params) {
                if (params.isImage) {
                    logo_repository
                    .LogoRepository
                    .save(params.uuid)
                    .done(function (logo) {
                        var img = {
                            title: logo.title,
                            id: logo.id,
                            src: logo.resource_thumbnail,
                        };

                        imageWorker.set(img);
                        addImgToList(nodes.getLogosContainer(), img);
                        addImgToPreview(nodes.imgPreview, img);
                        waitImg(logo.resource_thumbnail, function () {
                            showPreview(nodes.imgPreview);
                            progress.stop();
                        })
                    });
                }
            });
        });

        let image = storage.getObj("conf-email-img");

        if (nodes.selectedImg) {
            image = nodes.selectedImg.getAttribute("value");
            image = JSON.parse(image);
            setImg(image);
        }

        nodes.imgPreview.minusLogo.addEventListener("click", function () {
            hidePreview(nodes.imgPreview);
        });

        nodes.imgPreview.openBtn.addEventListener('click', function () {
            openUploadModal(uploadcare);
        });

        progress.stop();
    }

    let setDefaultColor = () => {
        let input = document.querySelector("#id_color");
        let defaultColor = input.getAttribute("data-default");
        document.querySelector(".minicolors-swatch-color").style = `background-color: ${defaultColor};`;
        input.value = defaultColor
    }

    let createEventListeners = () => {
        // open/close import form
        // nodes.importHeader.addEventListener("click", () => {
        //     if (nodes.importForm.classList.contains('active')) {
        //         nodes.importForm.classList.remove("active");
        //     } else {
        //         nodes.importForm.classList.add("active");
        //     }
        // })

        // functions to add text placeholder variables to text fields
        handleTextInserts(".add-item.customer", "{name}", ".email-subject");
        handleTextInserts(".add-item.project", "{project}", ".email-subject");
        handleTextInserts(".add-item.customer", "{name}", ".email-intro");
        handleTextInserts(".add-item.project", "{project}", ".email-intro");

        nodes.submitButton.addEventListener("click", (event) => {
            event.preventDefault();

            if(domainSelector.value === "-1") { // disable domain form input if selected value is default
                domainSelector.disabled = true;
            } else {
                domainSelector.disabled = false;
                validationConfigs.push(
                    {
                        input: nodes.form.emailAddress,
                        errorNode: nodes.form.emailAddressError,
                        validations: ["hasValue", "emailNameAddress"],
                    },
                    {
                        input: nodes.form.emailName,
                        errorNode: nodes.form.emailNameError,
                        validations: ["hasValue", "alphaNumeric"],
                    },
                )
            }
            
            let formIsValid = utilities.validateForm(validationConfigs);

            if(formIsValid) {
                nodes.mainForm.submit();
            }
        })

        nodes.previewButton.addEventListener("click", (event) => {
            event.preventDefault();

            if(domainSelector.value === "-1") { // disable domain form input if selected value is default
                domainSelector.disabled = true;
            } else {
                domainSelector.disabled = false;
            }

            let formIsValid = utilities.validateForm(validationConfigs);

            if(formIsValid) {
                let surveyId = nodes.previewButton.getAttribute("data-survey-id");
                showEmailPreview(surveyId);
            }
        })

        nodes.form.resetButtons.forEach(reset => {
            reset.addEventListener("click", () => {
                let input = reset.parentElement.querySelector('textarea');
                if(!input) {
                    input = reset.parentElement.querySelector('input');
                }
                
                input.value = input.getAttribute("data-default");

                if(input.name === 'color') {
                    setDefaultColor();
                }

                reset.classList.add("roll");

                setTimeout(() => {
                    reset.classList.remove("roll");
                }, 300);
            })
        })
    }

    return {
        init: function () {
            // This doesn't work ((((
            //let surveyId = nodes.previewButton.getAttribute("data-survey-id");
            //window.history.replaceState(null, null, urls['projects:start_projects_survey'](surveyId));
            //window.history.pushState(null, null, urls['projects:start_projects_survey_s2'](surveyId));

            // initialize color picker
            $('#id_color').minicolors($.minicolors.defaults);
           
            // add character limits to inputs
            utilities.addCharacterCount("#id_introduction", 140);
            utilities.addCharacterCount("#id_subject", 60)

            // initialize logo picker
            uploader.initializeAndWaitUntilReady(
                function(uploadcare){
                    uploaderCallback(uploadcare)
                }
            );
            customDomain.create(true);
            setDefaultLogo();
            createEventListeners();
            exitWarningGeneric();
        },
    };
});